var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _ellipse, _path8, _path9, _g2, _path0, _path1, _g3, _ellipse2, _path10, _g4, _path11, _g5, _path12, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLogoForget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 284,
    viewBox: "0 0 164 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2232 129.629L70.341 129.609C47.4464 129.456 29.6395 122.734 17.4107 109.597C-1.73458 89.0452 -0.00803331 60.4863 0.0736966 59.2827L0.298454 55.9679L3.63917 55.7333C3.63917 55.7333 4.57906 55.6619 6.23409 55.6619C17.5128 55.6619 73.7737 59.0481 74.2028 125.754L74.2232 129.629Z",
    fill: "url(#paint0_linear_9373_27057)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7368 101.504L78.0918 98.834C62.4897 83.0892 54.9115 66.3059 55.5653 48.9489C56.5857 21.7713 77.4083 3.37591 78.2999 2.61438L80.7368 0.488037L83.1836 2.61438C84.0751 3.37591 104.898 21.7713 105.918 48.9489C106.572 66.3059 98.9938 83.0892 83.3916 98.834L80.7368 101.504Z",
    fill: "url(#paint1_linear_9373_27057)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8079 129.629L89.8379 125.831C90.2584 60.4608 145.393 57.1423 156.436 57.1423C158.068 57.1423 158.989 57.2123 158.989 57.2123L162.253 57.4422L162.483 60.6907C162.563 61.8702 164.255 89.8474 145.493 109.998C133.519 122.872 116.059 129.459 93.6123 129.609L89.8079 129.629Z",
    fill: "url(#paint2_linear_9373_27057)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.064 283.763V101.647C109.526 101.611 108.998 101.611 108.46 101.611H54.8061V283.763H110.064ZM41.0555 283.763H54.8061V101.647H54.5054C32.2711 101.647 12.7523 119.761 11.1485 141.877L3.63077 243.579C1.98143 265.649 18.8303 283.763 41.0555 283.763ZM121.901 283.763C144.135 283.763 160.975 265.649 159.335 243.533L151.808 141.84C150.204 120.261 131.569 102.493 110.027 101.647V283.763H121.901Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 95,
    width: 72,
    height: 72
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0496 95.6482H163.072V166.555H92.0496V95.6482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9373_27057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 95,
    width: 72,
    height: 72
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.568 95.6635C107.949 95.6635 92.0571 111.53 92.0571 131.117C92.0571 150.695 107.949 166.57 127.568 166.57C147.178 166.57 163.079 150.695 163.079 131.117C163.079 111.53 147.178 95.6635 127.568 95.6635Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9373_27057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0571 95.6635H163.079V166.57H92.0571V95.6635Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.98 102C110.742 102 100.828 111.898 100.828 124.116C100.828 136.325 110.742 146.223 122.98 146.223C135.209 146.223 145.123 136.325 145.123 124.116C145.123 111.898 135.209 102 122.98 102Z",
    fill: "#3D1F1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.834,
    cy: 112.862,
    rx: 7.83399,
    ry: 7.80803,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 96,
    width: 72,
    height: 72
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 96.1361H71.0222V167.043H0V96.1361Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9373_27057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 96,
    width: 72,
    height: 72
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5111 96.1514C15.9012 96.1514 0 112.018 0 131.605C0 151.183 15.9012 167.058 35.5111 167.058C55.121 167.058 71.0222 151.183 71.0222 131.605C71.0222 112.018 55.121 96.1514 35.5111 96.1514Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9373_27057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 96.1514H71.0222V167.058H0V96.1514Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 102,
    width: 45,
    height: 45
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7095 102.366H62.9958V146.589H18.7095V102.366Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9373_27057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 102,
    width: 46,
    height: 45
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8602 102.366C28.6314 102.366 18.717 112.264 18.717 124.482C18.717 136.691 28.6314 146.589 40.8602 146.589C53.0891 146.589 63.0034 136.691 63.0034 124.482C63.0034 112.264 53.0891 102.366 40.8602 102.366Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9373_27057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.717 102.366H63.0034V146.589H18.717V102.366Z",
    fill: "#3D1F1E"
  })))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.834,
    cy: 112.862,
    rx: 7.83399,
    ry: 7.80803,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 228,
    width: 6,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8396 228.545H85.0721V229.08H80.8396V228.545Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9373_27057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0721 228.812C85.0721 228.83 85.0579 228.847 85.0312 228.864C85.0037 228.882 84.9638 228.898 84.9105 228.915C84.8572 228.931 84.7924 228.946 84.7152 228.961C84.638 228.975 84.5501 228.989 84.4516 229.001C84.3539 229.014 84.2465 229.025 84.1311 229.034C84.0157 229.044 83.8941 229.052 83.7654 229.059C83.6367 229.066 83.5044 229.071 83.3686 229.074C83.2319 229.078 83.0943 229.079 82.9558 229.079C82.8165 229.079 82.6789 229.078 82.5431 229.074C82.4064 229.071 82.2741 229.066 82.1454 229.059C82.0176 229.052 81.8951 229.044 81.7797 229.034C81.6643 229.025 81.5568 229.014 81.4592 229.001C81.3607 228.989 81.2728 228.975 81.1956 228.961C81.1183 228.946 81.0535 228.931 81.0003 228.915C80.947 228.898 80.9071 228.882 80.8795 228.864C80.8529 228.847 80.8396 228.83 80.8396 228.812C80.8396 228.795 80.8529 228.777 80.8795 228.76C80.9071 228.743 80.947 228.726 81.0003 228.71C81.0535 228.694 81.1183 228.679 81.1956 228.664C81.2728 228.649 81.3607 228.636 81.4592 228.623C81.5568 228.611 81.6643 228.6 81.7797 228.59C81.8951 228.58 82.0176 228.572 82.1454 228.566C82.2741 228.559 82.4064 228.554 82.5431 228.55C82.6789 228.547 82.8165 228.545 82.9558 228.545C83.0943 228.545 83.2319 228.547 83.3686 228.55C83.5044 228.554 83.6367 228.559 83.7654 228.566C83.8941 228.572 84.0157 228.58 84.1311 228.59C84.2465 228.6 84.3539 228.611 84.4516 228.623C84.5501 228.636 84.638 228.649 84.7152 228.664C84.7924 228.679 84.8572 228.694 84.9105 228.71C84.9638 228.726 85.0037 228.743 85.0312 228.76C85.0579 228.777 85.0721 228.795 85.0721 228.812Z",
    fill: "#FA5B5B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 199,
    width: 27,
    height: 30
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6738 199.104H95.376V228.227H69.6738V199.104Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9373_27057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2568 228.385C81.742 228.385 81.2328 228.354 80.7293 228.291C80.223 228.229 79.7337 228.136 79.2586 228.014C78.7836 227.89 78.3313 227.741 77.9046 227.563C77.4751 227.385 77.0797 227.182 76.7156 226.956C76.3515 226.728 76.0272 226.482 75.7427 226.216C75.4554 225.95 75.2136 225.668 75.0174 225.371C74.8211 225.076 74.6732 224.771 74.5708 224.457C74.4712 224.142 74.4229 223.825 74.4229 223.504C74.4229 223.184 74.4712 222.866 74.5708 222.552C74.6732 222.238 74.8211 221.933 75.0174 221.636C75.2136 221.341 75.4554 221.059 75.7427 220.794C76.0272 220.527 76.3515 220.281 76.7156 220.053C77.0797 219.827 77.4751 219.624 77.9046 219.446C78.3313 219.268 78.7836 219.119 79.2586 218.995C79.7337 218.873 80.223 218.78 80.7293 218.718C81.2328 218.655 81.742 218.625 82.2568 218.625C82.7717 218.625 83.2809 218.655 83.7844 218.718C84.2907 218.78 84.78 218.873 85.255 218.995C85.7301 219.119 86.1824 219.268 86.6091 219.446C87.0386 219.624 87.434 219.827 87.7981 220.053C88.1622 220.281 88.4865 220.527 88.7709 220.794C89.0583 221.059 89.3 221.341 89.4963 221.636C89.6926 221.933 89.8405 222.238 89.9429 222.552C90.0425 222.866 90.0908 223.184 90.0908 223.504C90.0908 223.825 90.0425 224.142 89.9429 224.457C89.8405 224.771 89.6926 225.076 89.4963 225.371C89.3 225.668 89.0583 225.95 88.7709 226.216C88.4865 226.482 88.1622 226.728 87.7981 226.956C87.434 227.182 87.0386 227.385 86.6091 227.563C86.1824 227.741 85.7301 227.89 85.255 228.014C84.78 228.136 84.2907 228.229 83.7844 228.291C83.2809 228.354 82.7717 228.385 82.2568 228.385Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9373_27057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 218,
    width: 23,
    height: 17
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1387 218.482H93.3636V234.43H71.1387V218.482Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9373_27057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3984 226.205C89.3984 226.369 89.3513 226.53 89.2631 226.692C89.1719 226.853 89.0395 227.009 88.863 227.16C88.6865 227.312 88.4718 227.455 88.2159 227.592C87.9599 227.727 87.6687 227.854 87.3422 227.969C87.0186 228.086 86.6627 228.189 86.2803 228.28C85.8979 228.371 85.4949 228.447 85.0683 228.51C84.6418 228.573 84.2035 228.621 83.7534 228.653C83.3004 228.685 82.8445 228.701 82.3856 228.701C81.9238 228.701 81.4678 228.685 81.0177 228.653C80.5647 228.621 80.1264 228.573 79.6999 228.51C79.2763 228.447 78.8704 228.371 78.488 228.28C78.1056 228.189 77.7496 228.086 77.426 227.969C77.0995 227.854 76.8083 227.727 76.5524 227.592C76.2965 227.455 76.0817 227.312 75.9052 227.16C75.7287 227.009 75.5964 226.853 75.5052 226.692C75.4169 226.53 75.3728 226.369 75.3728 226.205C75.3728 226.041 75.4169 225.879 75.5052 225.717C75.5964 225.557 75.7287 225.401 75.9052 225.249C76.0817 225.098 76.2965 224.955 76.5524 224.818C76.8083 224.682 77.0995 224.555 77.426 224.44C77.7496 224.324 78.1056 224.22 78.488 224.13C78.8704 224.038 79.2763 223.962 79.6999 223.899C80.1264 223.837 80.5647 223.789 81.0177 223.756C81.4678 223.724 81.9238 223.708 82.3856 223.708C82.8445 223.708 83.3004 223.724 83.7534 223.756C84.2035 223.789 84.6418 223.837 85.0683 223.899C85.4949 223.962 85.8979 224.038 86.2803 224.13C86.6627 224.22 87.0186 224.324 87.3422 224.44C87.6687 224.555 87.9599 224.682 88.2159 224.818C88.4718 224.955 88.6865 225.098 88.863 225.249C89.0395 225.401 89.1719 225.557 89.2631 225.717C89.3513 225.879 89.3984 226.041 89.3984 226.205Z",
    fill: "#FA5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9373_27057",
    x1: 37.1116,
    y1: 55.6619,
    x2: 37.1116,
    y2: 129.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9373_27057",
    x1: 80.7417,
    y1: 0.488037,
    x2: 80.7417,
    y2: 101.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9373_27057",
    x1: 126.182,
    y1: 57.1423,
    x2: 126.182,
    y2: 129.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLogoForget);
export default __webpack_public_path__ + "static/media/passwordLogoForget.2135606935c77bf993183503be4b8df1.svg";
export { ForwardRef as ReactComponent };